module.exports = __webpack_public_path__ + "img/016-pilot.52e27548.png";